// Intent (1.2.0): one shared "where to after a successful login" decision for
// all three login paths (Google / e-mail link / e-mail code). SMS 2FA comes
// FIRST when the account has a phone this session never proved (financial data
// double lock — the server gates the cloud pull the same way), then the usual
// CRM match routing (same rules as auth/code.tsx).

import { router } from 'expo-router';

import { useAuthStore } from '@/store/auth-store';

export function routeAfterLogin() {
  const { requiresSmsVerify, matchStatus } = useAuthStore.getState();
  if (requiresSmsVerify) {
    router.replace({ pathname: '/auth/add-phone', params: { mode: 'restore' } } as never);
    return;
  }
  if (matchStatus === 'SINGLE_MASKED' || matchStatus === 'MULTIPLE') {
    router.replace('/auth/connect');
    return;
  }
  router.dismissTo('/menu' as never);
}
